import { Icon, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

interface LinkStackProps {
    card?: boolean;
    className?: string;
    children?: ReactNode;
    onClick(): void;
}

export const LinkStack: FC<LinkStackProps> = ({ card, children, className, onClick }) => (
    <Stack
        className={classNames(
            'cursor-pointer',
            {
                'border border-radius-2 bg-white p-2': card,
            },
            className
        )}
        onClick={onClick}
    >
        <Stack.Item fill>{children}</Stack.Item>

        <Stack direction="column" justifyContent="center">
            <Icon className="c-neutral-80" size={20} name="chevron_right" />
        </Stack>
    </Stack>
);
